import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import { TechRadarEntity } from '@developer-portal/plugin-catalog-common';
import crossFetch from 'cross-fetch';

export class TechRadarClient implements TechRadarApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi || { fetch: crossFetch };
  }

  async load(id: string | undefined) {
    const baseUrl = await this.discoveryApi.getBaseUrl('catalog');
    const data = await this.fetchApi.fetch(`${baseUrl}/entities/by-name/techradar/default/${id}`);
    const {
      spec: { quadrants = [], entries = [], rings = [] },
    } = (await data.json()) as TechRadarEntity;
    // Converts the timeline dates into date objects
    return {
      quadrants,
      rings,
      entries: entries.map(entry => ({
        ...entry,
        timeline: entry.timeline.map(timeline => ({
          ...timeline,
          date: new Date(timeline.date),
        })),
      })),
    };
  }
}
